import { api } from '@/shared/lib/api';
import type { AppFeatures, AuthUser, DemoUser, LoginPayload } from './types';

export const authApi = {
  /** `features` = flagi środowiskowe backendu (brak pola w starszym backendzie = wszystko wyłączone). */
  me: () => api.get<{ user: AuthUser; features?: Partial<AppFeatures> }>('/auth/me'),
  login: (payload: LoginPayload) => api.post<{ user: AuthUser }>('/auth/login', payload).then((r) => r.user),
  logout: () => api.post<void>('/auth/logout'),
};

export const demoApi = {
  users: () => api.get<DemoUser[]>('/demo/users'),
  switchTo: (userId: string) => api.post<{ user: AuthUser }>('/demo/switch', { userId }).then((r) => r.user),
};
